export class GetStatesAction {
  static readonly type = '[State] Get';
  constructor(public country_id?: number) {}
}
